import s from '../allservices.jsx'

export const getCardActivityService = (actionCallback, id, startDate, endDate, statementPeriod,transactionType) => {
    let token = "Token " + localStorage.getItem('token')
    const state = {
        activityFromDate: startDate || "",
        activityToDate: endDate || "",
        applicationId: "gmcabs",
        cardDetailsId: id,
        statementPeriod: statementPeriod ,
        transactionType:transactionType
    }
    fetch(s.get_cardactivity,{
        method: "POST",
        headers: {
            'content-type': 'application/json',
            'Authorization': token
        },
        body: JSON.stringify(state)

    })
    .then(res => {
        if (res.status === 200 || res.status === 201) {
            res.json().then(json => actionCallback(json, "success", res.status))
        } else if (res.status === 204) {
            actionCallback({ "transactions": [] }, "success", res.status)
        } else {
            actionCallback([], res.headers.get('message'), res.status)
        }
    })
}


// WEBPACK FOOTER //
// ./src/services/components/get_cardactivity.jsx